export class DrawingInterface {
    constructor() { }
    get canvas() { return this._canvas; }
    get context() { return this._context; }
    ;
    set context(value) {
        this._context = value;
    }
}
